import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import { Checkbox } from '@mui/material';
import { User } from '../../../../../../model/user/User';

interface IConfirmationModalProps {
    action?: any;
    grandTotal: string | 0;
    show: boolean;
    closeModal: () => void;
    disableButton: boolean;
    nbPosts?: number;
    user?: User;
    isInfluencer?: boolean;
    isContract?: boolean;
    isChildOffer?: boolean;
    contractId?: number;
    isFirstOfferAcceptEnabled?: boolean;
    isProposal?: boolean;
    isProposalApproval?: boolean;
}

export function ConfirmSendingOfferModal({
    action,
    show,
    closeModal,
    grandTotal,
    nbPosts,
    user,
    disableButton,
    isInfluencer = false,
    isContract,
    isChildOffer,
    contractId,
    isFirstOfferAcceptEnabled = false,
    isProposal = false,
    isProposalApproval = false,
}: IConfirmationModalProps) {
    const { t } = useTranslation();
    const [isRequired, setIsRequired] = useState(false);

    const confirmSending = () => {
        if (isRequired) {
            action();
            closeModal();
        }
    };
    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setIsRequired(checked);
    };

    return (
        <Modal
            show={show}
            onHide={closeModal}
            className="modal-dark"
            size={undefined}
            aria-labelledby="contained-modal-title-vcenter"
            centered={true}
        >
            <Modal.Body>
                <div className="mt-4 d-flex align-items-center justify-content-center flex-column">
                    <h4 className="text-primary text-center">
                        {isProposalApproval
                            ? t('brand.campaign.book.offer.approve_proposal')
                            : isProposal
                            ? t('brand.campaign.book.offer.send_proposal_title')
                            : isContract
                            ? t('brand.campaign.book.contract.send_contract')
                            : t(`brand.campaign.book.offer.${isChildOffer ? 'send_child_offer' : 'send_offer'}`)}
                    </h4>
                </div>
                <div className="text-center">
                    <p className="text-muted">
                        {isProposalApproval
                            ? t('brand.campaign.book.offer.confirm_approve_proposal')
                            : isProposal
                            ? t('brand.campaign.book.offer.confirm_submit_proposal')
                            : isContract
                            ? t('brand.campaign.book.contract.confirm_submit_contract')
                            : t(
                                  `brand.campaign.book.offer.${
                                      isChildOffer ? 'confirm_submit_child_offer' : 'confirm_submit_offer'
                                  }`
                              )}
                    </p>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                    <h6 className="mr-1">{isInfluencer ? '' : user?.firstName + ' ' + user?.lastName + ' ,'}</h6>
                    <div className="d-flex align-items-center mr-1">
                        <h6 className="text-primary mr-1">{!!nbPosts ? nbPosts : ''}</h6>
                        {nbPosts === 0 ? (
                            <h6>{t('brand.campaign.book.offer.addons_only')}</h6>
                        ) : (
                            <h6>
                                {t(
                                    `brand.campaign.book.offer.${
                                        isChildOffer ? 'content_pieces' : 'content_pieces_for'
                                    }`
                                )}
                            </h6>
                        )}
                    </div>
                    {!isChildOffer && <h6 className="euro-symbol euro-symbol text-primary">{grandTotal}</h6>}
                </div>
                <p className="mt-2 text-center">
                    {isProposalApproval
                        ? t('brand.campaign.book.offer.confirm_approve_proposal_desc')
                        : isProposal
                        ? t(
                              isContract
                                  ? 'brand.campaign.book.offer.confirm_submit_contract_proposal_desc'
                                  : 'brand.campaign.book.offer.confirm_submit_proposal_desc'
                          )
                        : isInfluencer
                        ? t('brand.campaign.book.offer.confirm_submit_offer_desc_inf')
                        : isContract
                        ? t('brand.campaign.book.contract.confirm_submit_contract_desc')
                        : t(
                              `brand.campaign.book.offer.${
                                  isChildOffer ? 'confirm_submit_child_offer_desc' : 'confirm_submit_offer_desc'
                              }`,
                              { contractId }
                          )}
                </p>
                <div className="d-flex align-items-center mt-3">
                    <Checkbox
                        className="mb-0"
                        required
                        id="checkbox"
                        onChange={changeHandler}
                        color="primary"
                        checked={isRequired}
                    />
                    <label
                        htmlFor="checkbox"
                        className={`text-start cursor-pointer mb-0 text-muted`}
                        dangerouslySetInnerHTML={{ __html: t('brand.campaign.book.offer.terms') }}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button onClick={closeModal} variant="outline-primary" className="btn-sm mx-2">
                    {t('general.button.close')}
                </Button>
                <Button
                    disabled={!isRequired || disableButton}
                    variant="primary"
                    className="btn-sm mx-2"
                    onClick={confirmSending}
                >
                    {isProposal
                        ? t('general.button.send')
                        : isFirstOfferAcceptEnabled
                        ? t('general.button.accept')
                        : t('brand.campaign.book.contract.sign')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
